var createStylesheet = function(chunkId, fullhref, resolve, reject) {
	var linkTag = document.createElement("link");

	linkTag.rel = "stylesheet";
	linkTag.type = "text/css";
	var onLinkComplete = function(event) {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && (event.type === 'load' ? 'missing' : event.type);
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	linkTag.href = fullhref;

	document.head.appendChild(linkTag);
	return linkTag;
};
var findStylesheet = function(href, fullhref) {
	var existingLinkTags = document.getElementsByTagName("link");
	for(var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}
	var existingStyleTags = document.getElementsByTagName("style");
	for(var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if(dataHref === href || dataHref === fullhref) return tag;
	}
};
var loadStylesheet = function(chunkId) {
	return new Promise(function(resolve, reject) {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if(findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, resolve, reject);
	});
}
// object to store loaded CSS chunks
var installedCssChunks = {
	"runtime": 0
};

__webpack_require__.f.miniCss = function(chunkId, promises) {
	var cssChunks = {"src_components_atoms_DecoHalfCircle_index_tsx":1,"src_components_atoms_SectionHead_index_tsx":1,"src_components_atoms_ListCard_index_tsx":1,"src_components_atoms_TagCard_index_tsx":1,"src_components_molecules_CarouselBanner_index_tsx":1,"home":1,"page":1,"commons-news-swiper.css|0":1,"commons-news-thumbs.css|0":1,"commons-news-pagination.css|0":1,"commons-news-navigation.css|0":1,"commons-news-free-mode.css|0":1,"commons-news-effect-fade.css|0":1,"src_components_atoms_Pagination_index_tsx":1,"news":1,"src_components_atoms_Breadcrumbs_index_tsx":1,"src_components_molecules_ShareLinkGroup_index_tsx":1,"src_components_atoms_Article_index_module_css":1,"src_components_atoms_HeroBanner_index_tsx":1,"newsDetail":1,"event":1,"EventDetail":1,"src_components_atoms_DropdownSelect_index_tsx":1,"src_components_atoms_Modal_index_tsx":1,"src_components_molecules_RadioGroup_index_tsx":1,"src_components_atoms_MagazineCard_index_tsx":1,"src_components_atoms_PublicationCard_index_tsx":1,"sponsorUsDetail":1,"award":1,"src_routes_Fountain_Magazine_component_tsx":1,"src_routes_Fountain_Publication_component_tsx":1,"theme":1,"episode":1,"preview":1,"multiMedia":1,"read":1,"src_routes_Fountain_component_tsx":1,"src_routes_Search_component_tsx":1,"artisticEvent":1,"artisticEventDetail":1,"southTaipeiSpaceOne":1,"southTaipeiSpaceDetail":1,"src_components_molecules_ShoppingProgress_index_tsx":1,"sponsorList":1,"publications":1,"src_components_atoms_FormInput_index_tsx":1,"src_components_organisms_Auth_index_tsx":1,"src_components_atoms_ButtonFacebook_index_tsx":1,"src_routes_User_Login_component_tsx":1,"src_components_atoms_ReminderPrompt_index_tsx":1,"src_routes_User_SignUp_component_tsx":1,"src_components_molecules_SponsorRecord_index_tsx":1,"sponsorship":1,"src_components_molecules_SponsorRecordDetail_index_tsx":1,"sponsorshipDetail":1,"sponsorUs":1,"sponsorCheckout":1,"src_routes_User_ForgotPassword_component_tsx":1,"src_routes_User_ResetPassword_component_tsx":1,"src_routes_User_Welcome_component_tsx":1,"Member":1,"sponsorshipSuccess":1,"sponsorshipFail":1,"Copyright":1,"history":1,"links":1,"orgStructure":1,"ourMission":1,"privacy":1,"sponsoredBy":1,"TransportInfo":1,"unsubscribe":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = loadStylesheet(chunkId).then(function() {
			installedCssChunks[chunkId] = 0;
		}, function(e) {
			delete installedCssChunks[chunkId];
			throw e;
		}));
	}
};

// no hmr